/**
 * musical-ear-trainer — визуальный тренажёр музыкального слуха (все языки).
 *
 * Тот же каталог задач и те же записи фортепиано, что у голосовой игры
 * Игротеки «Слух музыканта» (App\Services\VoiceGames\Games\MusicalEar):
 * блейд кладёт их в window.__MET вместе с подписями из перевода. Раунд —
 * десять заданий; после ошибки можно послушать свой ответ рядом с верным.
 *
 * Звук играет только из клика — play() синхронно в обработчике, поэтому
 * примитив __audioGate (звук после await) здесь не нужен. Записи — десятки
 * килобайт, следующая подгружается заранее.
 *
 * Плоский ES5, без сборки.
 */
(function (global, doc) {
    'use strict';

    var D = global.__MET;
    var root = doc.getElementById('met');
    if (!D || !root) return;

    var T = D.T || {};
    var SLUG = 'musical-ear-trainer';
    var ROUND = 10;
    var MODES = ['intervals', 'majmin', 'chords', 'notes'];

    var $ = function (sel) { return root.querySelector(sel); };
    var els = {
        modes: $('[data-met-modes]'),
        levels: $('[data-met-levels]'),
        stage: $('[data-met-stage]'),
        progress: $('[data-met-progress]'),
        play: $('[data-met-play]'),
        playLabel: $('[data-met-play-label]'),
        question: $('[data-met-question]'),
        answers: $('[data-met-answers]'),
        feedback: $('[data-met-feedback]'),
        yours: $('[data-met-yours]'),
        next: $('[data-met-next]'),
        result: $('[data-met-result]')
    };

    var byAnswer = {};
    Object.keys(D.clips).forEach(function (k) {
        var c = D.clips[k];
        (byAnswer[c.a] = byAnswer[c.a] || []).push(k);
    });

    var S = { mode: 'intervals', level: 1, i: 0, right: 0, q: null, clip: null, last: null, answered: false, chosen: null, miss: [], played: false };
    var audio = doc.createElement('audio');
    audio.preload = 'auto';
    var warm = doc.createElement('audio');
    warm.preload = 'auto';

    // ── telemetry (slug из <meta name="tool-slug">) ────────────────────
    function ae(type, payload) { if (global.__ae) { try { global.__ae(type, payload || {}); } catch (e) {} } }
    function announce(msg) { try { if (global.__announce) global.__announce(msg); } catch (e) {} }
    function stage(name) { if (global.__stage) { try { global.__stage(name); } catch (e) {} } }

    // ── подписи ────────────────────────────────────────────────────────
    function fill(s, repl) {
        s = String(s || '');
        Object.keys(repl || {}).forEach(function (k) { s = s.split(':' + k).join(String(repl[k])); });
        return s;
    }
    function t(key, repl) { return fill(T[key], repl); }
    function nameOf(id) { return (T.answers && T.answers[id]) || id; }
    function levelName(mode, level) { return (T.levels && T.levels[mode] && T.levels[mode][level]) || String(level); }
    function options() { return (D.levels[S.mode] || {})[S.level] || []; }
    function hasLevel(mode, level) { return !!((D.levels[mode] || {})[level]); }
    function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

    // ── настройки ──────────────────────────────────────────────────────
    function loadSettings() {
        var ts = global.__toolSettings;
        if (!ts || typeof ts.load !== 'function') return;
        try {
            var m = ts.load(SLUG, 'mode', 'intervals');
            var l = parseInt(ts.load(SLUG, 'level', '1'), 10);
            if (MODES.indexOf(m) >= 0) S.mode = m;
            S.level = hasLevel(S.mode, l) ? l : 1;
        } catch (e) {}
    }
    function saveSettings() {
        var ts = global.__toolSettings;
        if (!ts || typeof ts.save !== 'function') return;
        try { ts.save(SLUG, 'mode', S.mode); ts.save(SLUG, 'level', String(S.level)); } catch (e) {}
    }

    // ── звук ───────────────────────────────────────────────────────────
    function play(key) {
        var c = D.clips[key];
        if (!c) return;
        try {
            audio.pause();
            if (audio.getAttribute('src') !== c.u) audio.src = c.u;
            audio.currentTime = 0;
            var p = audio.play();
            if (p && typeof p.catch === 'function') p.catch(function (err) { ae('diagnostic', { issue: 'met_play_failed', n: String(err && err.name || '') }); });
        } catch (e) {}
    }
    function prefetch(key) {
        var c = D.clips[key];
        if (!c) return;
        try { warm.src = c.u; warm.load(); } catch (e) {}
    }

    // ── раунд ──────────────────────────────────────────────────────────
    function newRound(autoplay) {
        S.i = 0;
        S.right = 0;
        S.miss = [];
        S.q = null;
        els.result.hidden = true;
        els.stage.hidden = false;
        stage('round_start');
        nextQuestion(autoplay);
    }

    function nextQuestion(autoplay) {
        var opts = options();
        var q;
        do { q = pick(opts); } while (opts.length > 2 && q === S.q && Math.random() < 0.67);
        var clips = (byAnswer[q] || []).filter(function (k) { return k !== S.last; });
        if (!clips.length) clips = byAnswer[q] || [];
        S.q = q;
        S.clip = pick(clips);
        S.last = S.clip;
        S.answered = false;
        S.chosen = null;
        renderQuestion();
        if (autoplay) {
            play(S.clip);
            S.played = true;
            renderPlay();
        }
    }

    function answer(id) {
        if (S.answered) return;
        if (!S.played) {
            // Ответ до звука — это промах мимо задачи, а не ответ: сначала послушать.
            els.feedback.textContent = t('listen_first');
            return;
        }
        S.answered = true;
        S.chosen = id;
        var ok = id === S.q;
        if (ok) S.right++;
        else S.miss.push([S.q, id]);
        markAnswers();
        els.progress.textContent = t('progress', { n: S.i + 1, total: ROUND, right: S.right });
        els.feedback.textContent = ok ? t('fb_right', { answer: nameOf(S.q) }) : wrongLine(S.q, id);
        els.feedback.className = 'met-feedback ' + (ok ? 'is-right' : 'is-wrong');
        els.yours.hidden = ok;
        els.next.hidden = false;
        els.next.textContent = S.i + 1 >= ROUND ? t('to_result') : t('next');
        try { els.next.focus({ preventScroll: true }); } catch (e) {}
        if (S.i === 0) ae('feature_use', { f: 'first_answer', mode: S.mode, level: S.level });
    }

    function wrongLine(want, got) {
        if (S.mode === 'notes') {
            var d = ((parseInt(got.slice(1), 10) - parseInt(want.slice(1), 10)) % 12 + 18) % 12 - 6;
            var table = (d > 0 ? T.dist_up : T.dist_down) || {};
            var dist = d === -6 ? t('dist_tritone') : fill(table[Math.abs(d)] || '', {});
            return t('fb_note_wrong', { answer: nameOf(want), chosen: nameOf(got), dist: dist });
        }
        var line = t('fb_wrong', { answer: nameOf(want), chosen: nameOf(got) });
        var ch = T.character && T.character[want];
        return ch ? line + ' ' + fill(ch, {}) : line;
    }

    /** Ваш ответ рядом с верным: та же высота, если такая запись есть. */
    function yoursClip() {
        var cur = D.clips[S.clip];
        var list = byAnswer[S.chosen] || [];
        if (!cur || !list.length) return null;
        if (S.mode === 'notes') {
            var pc = parseInt(S.chosen.slice(1), 10);
            var midi = cur.r - (cur.r % 12) + pc;
            return D.clips['muz.n' + midi] ? 'muz.n' + midi : list[0];
        }
        var best = list[0];
        list.forEach(function (k) { if (Math.abs(D.clips[k].r - cur.r) < Math.abs(D.clips[best].r - cur.r)) best = k; });
        return best;
    }

    function next() {
        if (!S.answered) return;
        S.i++;
        if (S.i >= ROUND) {
            showResult();
            return;
        }
        nextQuestion(true);
    }

    function showResult() {
        els.stage.hidden = true;
        var verdict = S.right === ROUND ? t('verdict_10') : S.right >= ROUND - 2 ? t('verdict_8') : S.right >= ROUND - 4 ? t('verdict_6') : t('verdict_low');
        var box = els.result;
        box.innerHTML = '';
        var score = doc.createElement('p');
        score.className = 'met-score';
        score.textContent = t('score', { right: S.right, total: ROUND });
        box.appendChild(score);
        var v = doc.createElement('p');
        v.className = 'met-verdict';
        v.textContent = verdict;
        box.appendChild(v);

        var note = '';
        if (S.mode === 'notes') {
            note = S.right >= 9 ? t('pp_yes') : t('pp_chance', { n: options().length });
        } else {
            var pairs = {};
            S.miss.forEach(function (m) { var k = m[0] + '|' + m[1]; pairs[k] = (pairs[k] || 0) + 1; });
            var top = Object.keys(pairs).sort(function (a, b) { return pairs[b] - pairs[a]; })[0];
            if (top) note = t('confused', { a: nameOf(top.split('|')[0]), b: nameOf(top.split('|')[1]) });
        }
        if (note) {
            var n = doc.createElement('p');
            n.className = 'met-note';
            n.textContent = note;
            box.appendChild(n);
        }
        if (S.miss.length) {
            var h = doc.createElement('p');
            h.className = 'met-h3';
            h.textContent = t('mistakes');
            box.appendChild(h);
            var ul = doc.createElement('ul');
            ul.className = 'met-mistakes';
            // Одинаковая ошибка — одной строкой со счётом: «квинта — кварта ×3».
            var seen = {}, order = [];
            S.miss.forEach(function (m) { var k = m[0] + '|' + m[1]; if (!seen[k]) { seen[k] = 0; order.push(m); } seen[k]++; });
            order.forEach(function (m) {
                var li = doc.createElement('li');
                var n = seen[m[0] + '|' + m[1]];
                li.textContent = t('mistake_line', { answer: nameOf(m[0]), chosen: nameOf(m[1]) }) + (n > 1 ? ' ×' + n : '');
                ul.appendChild(li);
            });
            box.appendChild(ul);
        }
        var row = doc.createElement('div');
        row.className = 'met-actions';
        row.appendChild(button(t('next_round'), 'met-btn met-btn-primary', function () { newRound(true); }));
        if (hasLevel(S.mode, S.level + 1)) {
            row.appendChild(button(t('harder'), 'met-btn', function () { setLevel(S.level + 1); }));
        }
        box.appendChild(row);
        box.hidden = false;
        // Итог раунда — вслух: область результата показана из скрытой, и диктор её не читает сам.
        announce(score.textContent + '. ' + verdict + (note ? ' ' + note : ''));
        try { row.firstChild.focus({ preventScroll: true }); } catch (e) {}

        if (global.__aeToolComplete) {
            try { global.__aeToolComplete({ t: 'met_round', mode: S.mode, level: S.level, right: S.right, total: ROUND }); } catch (e) {}
        }
    }

    function button(label, cls, onClick) {
        var b = doc.createElement('button');
        b.type = 'button';
        b.className = cls;
        b.textContent = label;
        b.addEventListener('click', onClick);
        return b;
    }

    // ── отрисовка ──────────────────────────────────────────────────────
    function renderModes() {
        Array.prototype.forEach.call(els.modes.querySelectorAll('[data-met-mode]'), function (b) {
            b.setAttribute('aria-pressed', b.getAttribute('data-met-mode') === S.mode ? 'true' : 'false');
        });
        els.levels.innerHTML = '';
        var levels = Object.keys(D.levels[S.mode] || {});
        els.levels.hidden = levels.length < 2;
        levels.forEach(function (l) {
            var lv = parseInt(l, 10);
            var b = button(levelName(S.mode, lv), 'met-chip', function () { setLevel(lv); });
            b.setAttribute('aria-pressed', lv === S.level ? 'true' : 'false');
            els.levels.appendChild(b);
        });
    }

    function renderPlay() {
        els.playLabel.textContent = S.played ? t('replay') : t('play');
    }

    function renderQuestion() {
        els.progress.textContent = t('progress', { n: S.i + 1, total: ROUND, right: S.right });
        els.question.textContent = (T.questions && T.questions[S.mode]) || '';
        els.answers.innerHTML = '';
        options().forEach(function (id, k) {
            var b = button(nameOf(id), 'met-ans', function () { answer(id); });
            b.setAttribute('data-id', id);
            if (k < 10) b.setAttribute('aria-keyshortcuts', String((k + 1) % 10));
            els.answers.appendChild(b);
        });
        els.answers.className = 'met-answers' + (options().length > 6 ? ' is-many' : '');
        els.feedback.textContent = '';
        els.feedback.className = 'met-feedback';
        els.yours.hidden = true;
        els.next.hidden = true;
        S.played = false;
        renderPlay();
        // Следующая запись — заранее: ответ, потом «дальше», и звук уже здесь.
        prefetch(S.clip);
    }

    function markAnswers() {
        Array.prototype.forEach.call(els.answers.querySelectorAll('[data-id]'), function (b) {
            var id = b.getAttribute('data-id');
            if (id === S.q) b.classList.add('is-right');
            else if (id === S.chosen) b.classList.add('is-wrong');
            b.setAttribute('aria-disabled', 'true');
        });
    }

    function setMode(mode) {
        if (MODES.indexOf(mode) < 0) return;
        S.mode = mode;
        S.level = 1;
        saveSettings();
        renderModes();
        ae('feature_use', { f: 'mode', mode: mode });
        newRound(true);
    }

    function setLevel(level) {
        if (!hasLevel(S.mode, level)) return;
        S.level = level;
        saveSettings();
        renderModes();
        ae('feature_use', { f: 'level', mode: S.mode, level: level });
        newRound(true);
    }

    // ── события ────────────────────────────────────────────────────────
    Array.prototype.forEach.call(els.modes.querySelectorAll('[data-met-mode]'), function (b) {
        b.addEventListener('click', function () { setMode(b.getAttribute('data-met-mode')); });
    });
    els.play.addEventListener('click', function () {
        play(S.clip);
        if (!S.played) {
            S.played = true;
            renderPlay();
            if (S.i === 0) ae('feature_use', { f: 'play', mode: S.mode, level: S.level });
        }
    });
    els.yours.addEventListener('click', function () {
        var k = yoursClip();
        if (k) play(k);
        ae('feature_use', { f: 'hear_yours', mode: S.mode });
    });
    els.next.addEventListener('click', next);

    doc.addEventListener('keydown', function (e) {
        var tg = e.target;
        if (e.ctrlKey || e.metaKey || e.altKey) return;
        if (window.__keyOwnedByFocus ? (window.__keyOwnedByFocus(e) || !!(tg && tg.closest && tg.closest('[data-vgc]'))) : (tg && (tg.closest && tg.closest('input, textarea, select, [contenteditable], [data-vgc]')))) return;
        if (!root.contains(doc.activeElement) && doc.activeElement !== doc.body) return;
        if (els.stage.hidden) return;
        if (e.key === ' ' && !(tg && tg.tagName === 'BUTTON')) {
            e.preventDefault();
            els.play.click();
        } else if (e.key === 'Enter' && S.answered && !(tg && tg.tagName === 'BUTTON')) {
            e.preventDefault();
            next();
        } else if (/^[0-9]$/.test(e.key)) {
            var idx = e.key === '0' ? 9 : parseInt(e.key, 10) - 1;
            var opts = options();
            if (idx < opts.length) {
                e.preventDefault();
                answer(opts[idx]);
            }
        }
    });

    loadSettings();
    renderModes();
    newRound(false);
    global.__musicalEarTrainer = { state: S, answer: answer, next: next, setMode: setMode, setLevel: setLevel };
})(window, document);
